import type { NavigationsAndGlobalsQuery } from '#gql'

type Globals = Force<NavigationsAndGlobalsQuery>

export const useCmsStore = defineStore('cms', () => {
  const { locale } = useI18n()
  const globals: Ref<Globals | undefined> = ref()

  const fetch = async () => {
    const { data, error } = await useAsyncGql({
      operation: 'NavigationsAndGlobals',
      variables: { lang: locale },
    })

    if (!data.value || error.value) {
      throw createError({
        fatal: true,
        message: 'Unable to fetch global data, check the server connection.',
        cause: error.value ?? 'Unkown error',
      })
    }

    globals.value = data.value as Globals
  }

  return {
    globals,
    fetch,
  }
})
